export const DateTypeFilterRoomMaintenance = [
    { value: 'all', label: 'All' },
    { value: 'date', label: 'Checkin & Checkout Date' },
    { value: 'checkin_date', label: 'Checkin Date' },
    { value: 'checkout_date', label: 'Checkout Date' },
];

export type DateTypeFilterRoomMaintenance = 'date' | 'checkin_date' | 'checkout_date';